@if (!loaderSpinner) {
    <div class="o-grid">
        <div class="o-grid__row">
            @if (!!request()?.requestPseudoId) {
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Request ID</h5>
                        <span>{{ request()?.requestPseudoId }}</span>
                    </div>
                </div>
            }

            @if (isSetFieldsVisibility() && request().erTrackingId) {
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Expense Report Tracking ID</h5>
                        <span>{{ request()?.erTrackingId }}</span>
                    </div>
                </div>
            }
        </div>

        @if (isNew()) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <span>
                        What are you requesting?
                        <span class="required-asterisk">*</span>
                    </span>
                </div>
            </div>
        }
        <div class="o-grid__row">
            <div class="o-grid__item">
                @if (isUpdate) {
                    <div id="requestType" class="c-info__block">
                        <h5>Request Type</h5>
                        <span>{{ getRequestTypeValue(request()?.type) }}</span>
                    </div>
                } @else {
                    <mds-radio-group
                        id="requestType"
                        [buttons]="requestTypeOptions"
                        [formCtrl]="requestTypeFormGroup.controls.requestTypeGroupControl"
                        (changeEvent)="selectRequestType($event.value, { id: 'requestType' })"
                    />
                }
            </div>
            @if (isSetFieldsVisibility() && request().erReportingPeriod) {
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>ER Reporting Period</h5>
                        <span>{{ request()?.erReportingPeriod }}</span>
                    </div>
                </div>
            }
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                @if (!travelDisabled || !paymentDisabled) {
                    <div class="unsupported-tier-message">
                        @if (!travelDisabled) {
                            <div>
                                <span>
                                    Your site is not set up or is unable to utilize {{ applicationName }} services.
                                    Please contact {{ emailAddress }} or your CRA with any questions or concerns.
                                </span>
                            </div>
                        }
                        @if (paymentDisabled) {
                            <div>
                                <span>
                                    Your site is not set up or is unable to utilize {{ applicationName }} services.
                                    Please contact {{ emailAddress }} or your CRA with any questions or concerns.
                                </span>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
} @else {
    <div class="o-grid">
        <medpace-loading-card></medpace-loading-card>
    </div>
}
